import "./App.css";
import { ReactLenis } from "lenis/dist/lenis-react";
import { useLenis } from "lenis/react";
import AppRoutes from "./AppRoutes";
import {
  Navbar,
  NavBody,
  NavItems,
  MobileNav,
  NavbarLogo,
  NavbarButton,
  MobileNavHeader,
  MobileNavToggle,
  MobileNavMenu,
} from "./Components/UI/navbar/resizable-navbar";

import { useNavigate } from "react-router-dom";
import { useState, useRef } from "react";

import { IoHomeOutline } from "react-icons/io5";
import { TfiGallery } from "react-icons/tfi";
import { MdOutlineDesignServices } from "react-icons/md";
import { FaBoxOpen } from "react-icons/fa";

import { routes } from "./Constants/Routes";
import ScrollToTop from "./Constants/ScrollToTop";

function App() {
  const navigate = useNavigate();
  const lenis = useLenis();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [hovered, setHovered] = useState(null);

  const servicesRef = useRef(null);
  const galleryRef = useRef(null);

  const scrollToSection = (target) => {
    const map = {
      services: servicesRef,
      gallery: galleryRef,
    };

    map[target]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const navbarRT = [
    {
      name: "მთავარი",
      type: "route",
      path: routes.Home,
      icon: <IoHomeOutline />,
      px: {
        xs: 0,
      },
    },

    {
      name: "სერვისები",
      type: "scrollPx",
      px: {
        xs: 1900,
        sm: 2000,
        base: 2200,
        basead: 2200,
        md: 2500,
        lg: 2000,
        xl: 2100,
      },
      icon: <MdOutlineDesignServices />,
    },

    {
      name: "ჩვენი ნამუშევრები",
      type: "scrollPx",
      px: {
        xs: 3800,
        sm: 4200,
        base: 4700,
        basead: 4800,
        md: 5000,
        lg: 5000,
        xl: 3500,
      },
      icon: <TfiGallery />,
    },

    {
      name: "შეკვეთა",
      type: "route",
      path: routes.GetOrder,
      icon: <FaBoxOpen />,
      px: {
        xs: 0,
      },
    },
  ];
  const getResponsivePx = (px) => {
    const w = window.innerWidth;

    if (typeof px === "number") return px;
    if (w >= 1280) return px.xl;
    if (w >= 1024) return px.lg;
    if (w >= 768) return px.md;
    if (w >= 620) return px.basead;
    if (w >= 550) return px.base;
    if (w >= 410) return px.sm;
    if (w >= 0) return px.xs;
    return px.base;
  };
  // const handleNavClick = (item) => {
  //   setIsMobileMenuOpen(false);

  //   if (item.type === "scrollPx") {
  //     // თუ უკვე Home-ზე არ ვართ → ჯერ Home-ზე გადასვლა
  //     if (window.location.pathname !== routes.Home) {
  //       navigate(routes.Home);

  //       // პატარა delay რომ Home დაიმაუნთოს
  //       setTimeout(() => {
  //         window.scrollTo({
  //           top: item.px,
  //           behavior: "smooth",
  //         });
  //       }, 100);
  //     } else {
  //       window.scrollTo({
  //         top: item.px,
  //         behavior: "smooth",
  //       });
  //     }

  //     return;
  //   }

  //   if (item.type === "route") {
  //     navigate(item.path);
  //   }
  // };
  const handleNavClick = (item) => {
    setIsMobileMenuOpen(false);

    if (item.type === "route") {
      if (window.location.pathname !== item.path) {
        navigate(item.path);
        requestAnimationFrame(() => {
          setTimeout(() => {
            window.scrollTo({
              top: 0,
              behavior: "auto",
            });

            lenis?.scrollTo(0, { duration: 0 });
          }, 50);
        });
      } else {
        window.scrollTo({ top: 0, behavior: "auto" });
      }

      return;
    }
    if (item.type === "scrollPx") {
      const targetPx = getResponsivePx(item.px);

      if (window.location.pathname !== routes.Home) {
        navigate(routes.Home);

        requestAnimationFrame(() => {
          setTimeout(() => {
            lenis?.scrollTo(targetPx, {
              duration: 1.2,
              easing: (t) => 1 - Math.pow(1 - t, 3),
            });
          }, 50);
        });

        return;
      }
      lenis?.scrollTo(targetPx, {
        duration: 1.2,
        easing: (t) => 1 - Math.pow(1 - t, 3),
      });

      return;
    }
    navigate(item.path);
  };
  return (
    <div className="App relative min-h-screen">
      <ReactLenis
        root
        options={{
          lerp: 0.07,
        }}
      >
        <div className="w-full bg-red-400">
          <Navbar>
            <NavBody>
              <NavbarLogo />

              <NavItems items={navbarRT} onItemClick={handleNavClick} />

              <div className="flex items-center gap-1">
                <NavbarButton variant="secondary" />
              </div>
            </NavBody>

            <MobileNav>
              <MobileNavHeader>
                <NavbarLogo />
                <MobileNavToggle
                  isOpen={isMobileMenuOpen}
                  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                />
              </MobileNavHeader>

              <MobileNavMenu
                isOpen={isMobileMenuOpen}
                onClose={() => setIsMobileMenuOpen(false)}
              >
                {navbarRT.map((item, idx) => (
                  <button
                    key={idx}
                    onClick={() => handleNavClick(item)}
                    className="flex items-center gap-2 text-neutral-300 hover:text-white"
                  >
                    {item.icon}
                    {item.name}
                  </button>
                ))}
              </MobileNavMenu>
            </MobileNav>
          </Navbar>
        </div>

        <div className="relative">
          {/* <ScrollToTop /> */}
          <AppRoutes />
          <div ref={servicesRef}></div>
          <div ref={galleryRef}></div>
        </div>
      </ReactLenis>
    </div>
  );
}

export default App;
